import { Card, CircularProgress, createTheme, IconButton, withStyles, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core/styles';
import RefreshIcon from '@material-ui/icons/Autorenew';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import { Entity, ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React, { Component } from 'react';
import { BLUE, SMARTLOCK_DOOR_STATUS_MAP, SMARTLOCK_DOOR_STATUS } from '../../../_config/consts';
import { getLockImage } from '../../../_config/utils';
import DoorSensorIconCustom from '../../CustomIcons/DoorSensorIconCustom.jsx';
import { FormControl } from '@sketchpixy/rubix';
import MDCheckBoxView from '../../forms/Fields/MDCheckBox/MDCheckBoxView';

const styles = theme => ({
  titleText: {
    margin: 0,
    fontWeight: 'bold',
    color: '#3f3f3f',
    marginTop: 5,
    textAlign: 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '99.9%',
    borderRadius: 10,
    padding: 15,
    marginTop: 20,
    marginBottom: 20,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    marginBottom: 20,
  },
  headerTextIconContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 10,
  },
  tableContainer: {
    width: '100%',
    maxHeight: 400,
    overflowY: 'scroll',
    marginTop: 0,
  },
  tableCell: {
    padding: '8px 16px',
  },
  nameCell: {
    fontWeight: 'bold',
    color: '#3f3f3f',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  iconCell: {
    width: 60,
    textAlign: 'center',
  },
  statusCell: {
    display: 'flex',
    alignItems: 'center',
  },
  refreshButton: {
    position: 'absolute',
    right: 15,
    top: 15,
  },
  refreshIcon: {
    fontSize: 25,
    color: '#3f3f3f',
  },
  tableRow: {
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04) !important',
    },
  },
  tableRowOpened: {
    transition: 'background-color 0.2s ease',
    backgroundColor: '#ffc4c4',
    '&:hover': {
      backgroundColor: '#ffb4b4 !important',
    },
  },
  searchContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
    width: '30%',
    marginTop: 10,
    borderRadius: 5,
  },
  searchHeader: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    marginBottom: 0,
  },
  statusCards: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-around',
    marginBottom: 20,
  },
  statusCard: {
    padding: 15,
    width: '45%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  statusFilter: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 20,
    marginTop: 7
  },
  icon: {
    width: 35,
    height: 35,
    borderRadius: 70,
  },
  tableColumnText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
});

const theme = createTheme({
  palette: {
    primary: { 500: BLUE },
  },
});

class StatusSensorMetricChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filteredData: props.accessoriesChartData,
      filterText: '',
      showOpened: false,
      showClosed: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { accessoriesChartData: newData } = nextProps;
    const { accessoriesChartData: oldData } = this.props;
    if (newData !== oldData) {
      this.filterData(this.state.filterText, this.state.showOpened, this.state.showClosed, newData);
    }
  }

  filterData(text, showOpened, showClosed, data = this.props.accessoriesChartData) {
    let filteredData = [...data];
    
    if (text) {
      filteredData = _.filter(filteredData, item => {
        const name = item.lock ? item.lock.name : item.sensor.name;
        return name.toLowerCase().includes(text.toLowerCase());
      });
    }

    // If at least one checkbox is selected, filter by status
    if (showOpened || showClosed) {
      filteredData = _.filter(filteredData, item => {
        if (!item.sensor || !item.sensor.value) return false;
        if (item.sensor.value === SMARTLOCK_DOOR_STATUS.OPENED) return showOpened;
        if (item.sensor.value === SMARTLOCK_DOOR_STATUS.CLOSED) return showClosed;
        return false;
      });
    }
    // If no checkbox is selected, show all statuses (no filtering)

    this.setState({ filteredData, filterText: text, showOpened, showClosed });
  }

  onSearchReset() {
    this.filterData('', false, false);
  }

  render() {
    const { accessoriesChartData, isRefreshing, onRefreshMetric, textColor, classes, onOpenLockDetails } = this.props;
    const { filteredData, filterText, showOpened, showClosed } = this.state;

    const openDoorsCount = _.filter(accessoriesChartData, item => 
      item.sensor && item.sensor.value === SMARTLOCK_DOOR_STATUS.OPENED
    ).length;

    const closedDoorsCount = _.filter(accessoriesChartData, item => 
      item.sensor && item.sensor.value === SMARTLOCK_DOOR_STATUS.CLOSED
    ).length;

    return (
      <MuiThemeProvider theme={theme}>
        <Card className={classes.container} elevation={3}>
          <div className={classes.header}>
            <h3 className={classes.titleText} style={{ color: textColor || '#3f3f3f' }}>
              <Entity entity="doorStatusChartTitle" />
            </h3>
            <IconButton
              className={classes.refreshButton}
              disabled={isRefreshing}
              style={{ opacity: isRefreshing ? 0.5 : 1 }}
              onClick={(e) => {
                e.stopPropagation();
                onRefreshMetric();
              }}
            >
              <RefreshIcon className={classes.refreshIcon} style={{ color: textColor || '#3f3f3f' }} />
            </IconButton>
          </div>
          <div className={classes.statusCards}>
            <Card className={classes.statusCard} elevation={2}>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                {SMARTLOCK_DOOR_STATUS_MAP.OPENED.icon}
                <h4 style={{ fontSize: 20, margin: 0, color: '#3f3f3f', marginLeft: 5 }}><Entity entity="openDoors" /></h4>
              </div>
              <h2 style={{ margin: '10px 0', color: '#ff4444' }}>{openDoorsCount}</h2>
            </Card>
            <Card className={classes.statusCard} elevation={2}>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                {SMARTLOCK_DOOR_STATUS_MAP.CLOSED.icon}
                <h4 style={{ fontSize: 20, margin: 0, color: '#3f3f3f', marginLeft: 5 }}><Entity entity="closedDoors" /></h4>
              </div>
              <h2 style={{ margin: '10px 0', color: '#4CAF50' }}>{closedDoorsCount}</h2>
            </Card>
          </div>

          <div className={classes.searchHeader}>
            <Card className={classes.searchContainer}>
              <FormControl
                value={filterText}
                placeholder={L20NContext.getSync('lockName')}
                className="form-control-noBorder"
                style={{ width: '100%', borderRadius: 5 }}
                onChange={e => this.filterData(e.target.value, showOpened, showClosed)}
              />
              {filterText ? (
                <IconButton style={{ height: 20, width: 20, marginLeft: -60, marginRight: 10 }} onClick={() => this.onSearchReset()}>
                  <CloseIcon />
                </IconButton>
              ) : null}
              <SearchIcon style={{ marginLeft: filterText ? 0 : -30 }} />
            </Card>
            <div className={classes.statusFilter}>
              <MDCheckBoxView
                checked={showOpened}
                onSelect={(value) => this.filterData(filterText, value, showClosed)}
                label={<Entity entity="showOpenStatus" />}
                titleStyle={{ color: '#3f3f3f' }}
              />
              <MDCheckBoxView
                checked={showClosed}
                onSelect={(value) => this.filterData(filterText, showOpened, value)}
                label={<Entity entity="showClosedStatus" />}
                titleStyle={{ color: '#3f3f3f' }}
              />
            </div>
          </div>
          <TableContainer className={classes.tableContainer}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <h5 className={classes.tableColumnText} style={{ color: textColor || 'gray' }}>
                      <Entity entity="name" />
                    </h5>
                  </TableCell>
                  <TableCell>
                    <h5 className={classes.tableColumnText} style={{ color: textColor || 'gray' }}>
                      <Entity entity="doorStatus" />
                    </h5>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {_.map(filteredData, (data) => {
                  const doorStatusVariables = data.sensor && data.sensor.value && SMARTLOCK_DOOR_STATUS_MAP[data.sensor.value] 
                    ? SMARTLOCK_DOOR_STATUS_MAP[data.sensor.value] 
                    : null;
                  const showDoorStatus = doorStatusVariables && data.sensor;
                  const lockAssociated = data.lock;
                  
                  if (!showDoorStatus) return null;
                  
                  return (
                    <TableRow 
                      key={lockAssociated ? lockAssociated.id : data.sensor.name}
                      onClick={lockAssociated && lockAssociated.id ? () => onOpenLockDetails(lockAssociated.id) : null}
                      className={data.sensor.value === SMARTLOCK_DOOR_STATUS.OPENED ? classes.tableRowOpened : classes.tableRow}
                      style={{ 
                        cursor: lockAssociated && lockAssociated.id ? 'pointer' : 'normal',
                        backgroundColor: data.sensor.value === SMARTLOCK_DOOR_STATUS.OPENED ? '#ffc4c4' : '',
                      }}
                    >
                      <TableCell className={classes.nameCell}>
                      {lockAssociated ? (
                          <img 
                            alt="lock" 
                            style={{ width: 35, height: 35, borderRadius: 70 }} 
                            src={getLockImage(lockAssociated.model)} 
                          />
                        ) : (
                          <DoorSensorIconCustom 
                            style={{ width: 30, height: 30, color: '#3f3f3f' }} 
                          />
                        )}
                        <h5 style={{ marginLeft: 15, color: '#3f3f3f', fontWeight: 'bold', fontSize: 16 }}>{lockAssociated ? data.lock.name : data.sensor.name}</h5>
                      </TableCell>
                      <TableCell>
                        <div className={classes.statusCell}>
                          {doorStatusVariables && doorStatusVariables.icon}
                          <h5>
                            <Entity 
                              key={doorStatusVariables.title} 
                            style={{ 
                              marginLeft: 5, 
                              fontWeight: 'bold', 
                              color: doorStatusVariables.color 
                            }} 
                            entity={doorStatusVariables.title} 
                          />
                          </h5>
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </MuiThemeProvider>
    );
  }
}

export default withStyles(styles)(StatusSensorMetricChart);
